module.exports = __webpack_public_path__ + "static/media/nikibi.329a38c3.webp";